module.exports = __webpack_public_path__ + "static/marc-andreessen-aa04b24617e946f08d40ed0d8077107e.jpg";